export function enumToNumberArray(enumerable) {
    return Object.keys(enumerable)
        .filter((value) => Number.isNaN(Number(value)) === false)
        .map((key) => Number(key));
}
